import axios from '../config/axiosConfig';

const API_URL = '/proxy-sessions';

const getAll = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

const create = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

const start = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/start`);
  return response.data;
};

const stop = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/stop`);
  return response.data;
};

const restart = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/restart`);
  return response.data;
};

// Hosts the proxy blocked as out-of-scope (for the tree surfacing)
const getOutOfScopeHosts = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/out-of-scope-hosts`);
  return response.data;
};

const addScopeHost = async (id, host, exact = false) => {
  const response = await axios.post(`${API_URL}/${id}/scope/add-host`, { host, exact });
  return response.data;
};

const removeScopeHost = async (id, host) => {
  const response = await axios.post(`${API_URL}/${id}/scope/remove-host`, { host });
  return response.data;
};

const updateScope = async (id, scope) => {
  const response = await axios.put(`${API_URL}/${id}/scope`, scope);
  return response.data;
};

// Live-update match/replace rules + response modifications on a running session
const updateModifications = async (id, { matchReplaceRules, responseModifications } = {}) => {
  const response = await axios.put(`${API_URL}/${id}/modifications`, { matchReplaceRules, responseModifications });
  return response.data;
};

const getCaCert = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/ca-cert`, {
    responseType: 'blob'
  });
  return response.data;
};

const getCapturedAuth = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/captured-auth`);
  return response.data;
};

const remove = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

// Cookie management
const getCookies = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/cookies`);
  return response.data;
};

const importCookies = async (id, cookies, comment) => {
  const response = await axios.post(`${API_URL}/${id}/cookies`, { cookies, comment });
  return response.data;
};

const deleteCookie = async (id, cookieName, domain) => {
  const params = domain ? { domain } : {};
  const response = await axios.delete(`${API_URL}/${id}/cookies/${encodeURIComponent(cookieName)}`, { params });
  return response.data;
};

const clearCookies = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}/cookies`);
  return response.data;
};

// Cloudflare solver
const startCloudflareSolver = async (id, targetUrl) => {
  const response = await axios.post(`${API_URL}/${id}/solve-cloudflare`, { targetUrl });
  return response.data;
};

const getCloudflareSolverProgress = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/solve-cloudflare/progress`);
  return response;
};

const proxyService = {
  getAll,
  getById,
  create,
  start,
  stop,
  restart,
  getCaCert,
  getOutOfScopeHosts,
  addScopeHost,
  removeScopeHost,
  updateScope,
  updateModifications,
  getCapturedAuth,
  remove,
  getCookies,
  importCookies,
  deleteCookie,
  clearCookies,
  startCloudflareSolver,
  getCloudflareSolverProgress
};

export default proxyService;
